export default __webpack_public_path__ + "static/media/checked.1512888c.png";